module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "p-toast-bottom"
    }
  }, [_c('aside', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showing),
      expression: "showing"
    }],
    staticClass: "p-toast-wrapper"
  }, [_c('div', {
    staticClass: "p-toast-container",
    class: _vm.type
  }, [_c('span', {
    staticClass: "p-toast-message",
    domProps: {
      "innerHTML": _vm._s(_vm.msg)
    }
  })])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e38f9068"}!./~/vue-loader/lib/selector.js?type=template&index=0!./vue/src/toast.vue
// module id = 37
// module chunks = 0